import { ReactEditor } from 'slate-react';
import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';

import { AulaPlugin } from '../plugins';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { insertQuiz } from './insertQuiz';

import { quizType, isQuizElement } from './quizType';
import { Quiz } from '../../components/Quiz/Quiz';

/**
 * quiz is a plugin to add an inline quiz block from Learnosity,
 * which is a third-party provider that we have integrated with.
 *
 * Note: The base of the plugin was copied from __example as stated
 * in the PLUGINS documentation. Check both for further understanding
 * of the base structure.
 */
export const quiz: AulaPlugin = (editableProps, editor, context) => {
  const { isVoid } = editor;
  editor.isVoid = (el) => el?.type === quizType || isVoid(el);

  return {
    ...editableProps,

    blockMenu: {
      ...editableProps.blockMenu,
      'Assignments & Quizzes': {
        ...(editableProps.blockMenu || {})['Assignments & Quizzes'],
        'Quiz item': ({ text, element, attributes, onClose }) => (
          <NestedMenuItem
            leftIcon={<icons.InlineQuiz />}
            key={text}
            text={text}
            attributes={{
              ...attributes,
              onClick: () => {
                if (onClose) {
                  onClose();
                }

                insertQuiz(
                  editor,
                  ReactEditor.findPath(editor, element),
                  context,
                );
              },
            }}
          />
        ),
      },
    },
    renderElement: (props) => {
      const { element, children, attributes } = props;

      if (isQuizElement(element)) {
        return (
          <div {...attributes}>
            <Quiz element={element} />
            {children}
          </div>
        );
      }

      return editableProps.renderElement?.(props) || <p />;
    },
  };
};
